// extracted by mini-css-extract-plugin
module.exports = {"headingContainer":"_18H2lSTCHNyYo4yy22cRBc","headingText":"_1udcFCoH_7-bFV4txy5xD4","venueFilter":"IhXRQ7ulqqxRaYsDF4EDN"};